
import Context from './context';
import Channel from './channel';
import Component from './component/component';

class Application extends Component {
  constructor(element, context, options) {
    super(element, context, options);
  }
}

const app = new Application(document.documentElement, new Context('app'));
app.channel = new Channel(app.context);

export default app;



// WEBPACK FOOTER //
// ./src/js/app/app.js